import React from "react";

const SvgInsight = props => (
  <svg
    className="insight__svg"
    viewBox="0 0 189.97083 140.22917"
    height={530}
    width={718}
    {...props}
  >
    <g transform="translate(0,-156.77081)">
      <rect
        y={175}
        x={47}
        height={30}
        width={40}
        id="insight__lines-background"
        style={{
          opacity: 1,
          fill: "#ffffff",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 7.16167641,
          strokeLinecap: "round",
          strokeMiterlimit: 4,
          strokeDasharray: "none",
          strokeOpacity: 1
        }}
      />
      <g id="insight__line-group1">
        <path
          style={{
            fill: "none",
            stroke: "#17253f",
            strokeWidth: 3.70416665,
            strokeLinecap: "round",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 0.99215686,
            fillOpacity: 1
          }}
          d="M 50.8,178.99581 H 61.520072"
          id="insight__line1"
        />
        <path
          id="insight__line2"
          d="M 50.8,185.34582 H 75.807572"
          style={{
            fill: "none",
            stroke: "#17253f",
            strokeWidth: 3.70416665,
            strokeLinecap: "round",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1
          }}
        />
      </g>
      <g id="insight__line-group2">
        <path
          style={{
            fill: "none",
            stroke: "#17253f",
            strokeWidth: 1.58749998,
            strokeLinecap: "round",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1
          }}
          d="M 50.270834,192.75406 H 84.803405"
          id="insight__line3"
        />
        <path
          id="insight__line4"
          d="M 50.270834,195.39988 H 84.803405"
          style={{
            fill: "none",
            stroke: "#17253f",
            strokeWidth: 1.58749998,
            strokeLinecap: "round",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1
          }}
        />
        <path
          id="insight__line5"
          d="M 50.270834,198.04573 H 84.803405"
          style={{
            fill: "none",
            stroke: "#17253f",
            strokeWidth: 1.58749998,
            strokeLinecap: "round",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1
          }}
        />
        <path
          style={{
            fill: "none",
            stroke: "#17253f",
            strokeWidth: 1.58749998,
            strokeLinecap: "round",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1
          }}
          d="M 50.270834,200.69155 H 84.803405"
          id="insight__line6"
        />
        <path
          id="insight__line7"
          d="M 50.270834,203.3374 H 76.336738"
          style={{
            fill: "none",
            stroke: "#17253f",
            strokeWidth: 1.58749998,
            strokeLinecap: "round",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1
          }}
        />
      </g>
    </g>
  </svg>
);

export default SvgInsight;




// WEBPACK FOOTER //
// ./frontend/pages/InfographicLanding/Insight.jsx